export default "__VITE_ASSET__DycI6VRh__"